import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const GET_ESMD_SUBMISSION_BY_AUDIT_ID = "GET_ESMD_SUBMISSION_BY_AUDIT_ID";

export const service = async (data) => {
  const options: object = {
    url: `/api/EsMD/GetEsmdAuditLevelSubmissionDetails/${data.auditId}`,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_ESMD_SUBMISSION_BY_AUDIT_ID, service, mock);
